import { FreeReducedMealAppAdultIncome } from './free-reduced-meal-app-adult-income.model';
import { FreeReducedMealAppPerson } from './free-reduced-meal-app-person.model';

export class FreeReducedMealAppAdult extends FreeReducedMealAppPerson {
    IsDeployed: boolean;
    Income: FreeReducedMealAppAdultIncome[] = [];
    IncomeTypeIds: number[] = [];

    //Non-DTO fields
    WorkIncome: number;
    OtherIncome: number;

    constructor() {
        super();
    }
   }